import { z } from 'zod';

/**
 * Which brand mark `GET /media/brand-logo` answers with (D10).
 *
 * A theme, not a colour: the client says which surface it is drawing on and the
 * api resolves `brand.logoMediaId` or `brand.logoDarkMediaId` — falling back to
 * the light mark when no dark one was uploaded, so a deployment with one logo
 * still answers every request.
 */
export const BRAND_LOGO_VARIANTS = ['light', 'dark'] as const;

export const BrandLogoVariantSchema = z.enum(BRAND_LOGO_VARIANTS);

export type BrandLogoVariant = (typeof BRAND_LOGO_VARIANTS)[number];
